import { Edit } from "lucide-react";
import { ModalTrigger } from "./ModalTrigger";

interface EditPortfolioTriggerProps {
  accountId: string | number;
  portfolioId: string;
  onPortfolioUpdated?: () => void;
}

export const EditPortfolioTrigger = ({
  accountId,
  portfolioId,
  onPortfolioUpdated,
}: EditPortfolioTriggerProps) => {
  if (onPortfolioUpdated) {
    (window as any).__portfolioUpdatedCallback = onPortfolioUpdated;
  }

  return (
    <ModalTrigger
      modalPath={`/modals/portfolio/${portfolioId}/edit`}
      modalState={{ portfolioId, accountId }}
      className="cursor-pointer w-6 h-6"
      size="icon"
      title="Edit Portfolio"
    >
      <Edit className="w-3 h-3" />
    </ModalTrigger>
  );
};
